import { Auth, authState, getAuth, signInWithEmailAndPassword, signOut, updatePassword } from '@angular/fire/auth';
import { inject, Injectable, signal } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Firestore, doc, getDoc, setDoc, updateDoc } from '@angular/fire/firestore';
import { UserData } from './user.interface';
import { Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../shared/loader';

@Injectable({ providedIn: 'root' })
export class UserService {
    firestore = inject(Firestore);
    toastService = inject(ToastService);
    private router = inject(Router);
    userId$: Observable<string | null>;
    currentWorkspaceId = signal('');
    currentUser = signal<UserData | null>(null);
    
  constructor(private auth: Auth) {
    this.userId$ = authState(this.auth).pipe(
      map(user => user ? user.uid : null)
    );
  }

  async createOrUpdateUser(userData: UserData) {
    const userRef = doc(this.firestore, `users/${userData.id}`);
    await setDoc(userRef, userData, { merge: true });
  }

  async getUser(id: string): Promise<UserData | null> {
    const userRef = doc(this.firestore, `users/${id}`);
    const snap = await getDoc(userRef);
    if (snap.exists()) {
      this.currentUser.set(snap.data() as UserData);
      return snap.data() as UserData;
    }
    return null;
  }

  async getWorkspaceIdForUser(userId: string): Promise<string | null> {
    const userDoc = await doc(this.firestore, `users/${userId}`);
    const data = await getDoc(userDoc);
     if (data.exists()) {
      this.currentWorkspaceId.set(data.data()['workspaceId'])
      return data.data()['workspaceId'];
    }
    return null;
  }

  logout() {
    return signOut(this.auth).then(() => {
      this.router.navigate(['/dashboard']);
    });
  }

  async updateUserData(data: any) {
    const user = await this.auth.currentUser;
    if (!user) return;

    const docRef = doc(this.firestore, `users/${user.uid}`);
    return updateDoc(docRef, data);
  }

  async changePassword(newPassword: string) {
    const user = await this.auth.currentUser;
    if (!user) return;
    return updatePassword(user, newPassword);
  }

}
